import styled from 'styled-components'

export const CarouselControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
  margin-top: 20px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 0;
  `}
`

export const CarouselButtonPrevious = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  background: #ffffff1a;
  border-radius: 100px;
  width: 100%;
  max-width: 120px;
  height: 38px;
  color: ${({ theme }) => theme.white};
  margin-bottom: 16px;
`

export const CarouselButtonNext = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  background: #ffffff1a;
  border-radius: 100px;
  width: 100%;
  max-width: 120px;
  height: 38px;
  color: ${({ theme }) => theme.white};
  margin-bottom: 16px;
  justify-self: end;
`

export const CarouselButtonPreviousImage = styled.img`
  margin-right: 15px;
`

export const CarouselButtonNextImage = styled.img`
  margin-left: 15px;
`
